import { useTranslation } from 'react-i18next'
import Tooltip from '@mui/material/Tooltip'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import { RichContent } from './RichContent'
import type { ApiContextualContent, ApiContentTag, GetContentBundleResponse } from '@/types/api'

interface ContextBlockProps {
  contextualContent: ApiContextualContent
  tag: ApiContentTag | undefined
  bundle: GetContentBundleResponse
  enableGlossary?: boolean
  seenTermIds?: Set<number>
  highlightTerm?: string
}

export function ContextBlock({ contextualContent, tag, bundle, enableGlossary, seenTermIds, highlightTerm }: ContextBlockProps) {
  const { t } = useTranslation()
  const displayName = tag?.displayName ?? tag?.name ?? t('content.contextSpecific')

  return (
    <div className="context-block" id={`cc-${contextualContent.id}`}>
      <div className="context-block-tag-name">
        {displayName}
        {tag?.description && (
          <Tooltip
            title={
              <div style={{ fontSize: 13 }}>
                <div style={{ fontWeight: 700, marginBottom: 4 }}>{tag.name}</div>
                <div>{tag.description}</div>
              </div>
            }
            placement="top"
            arrow
            slotProps={{ tooltip: { sx: { maxWidth: 320 } } }}
          >
            <HelpOutlineIcon className="context-block-tag-info-icon" fontSize="inherit" />
          </Tooltip>
        )}
      </div>
      <RichContent html={contextualContent.content ?? ''} original={contextualContent.originalFields?.content} bundle={bundle} enableGlossary={enableGlossary} seenTermIds={seenTermIds} highlightTerm={highlightTerm} />
    </div>
  )
}
